import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-text.styles'
import classNames from 'classnames'
import { withPresentation } from '../../presentation-connectors'
import { sanitizeHtml, urlifyHTML } from '../../utils'

const Text = ({
  classes,
  children,
  className,
  style,
  html,
  contrast,
  thumbnail
}) => {
  const innerHTML = useMemo(() => {
    if (!html) return null
    return { __html: sanitizeHtml(thumbnail ? html : urlifyHTML(html)) }
  }, [html])
  return (
    <div className={classNames(classes.container, className)} style={style}>
      {!innerHTML && children}
      {innerHTML && (
        <div
          className={classNames(classes.html, { [classes.contrast]: contrast })}
          dangerouslySetInnerHTML={innerHTML}
        />
      )}
    </div>
  )
}

export default withPresentation(injectSheet(styles)(Text))
